<template>
  <div class="page">
    <my-header :breadcrumb="breadcrumb"></my-header>
    <div class="content">
      <div class="content-wrap">
        <!--搜索-->
        <el-button type="primary" @click="clickAdd">添加文章</el-button>


        <!-- 工具栏（列表名称、列表显示项设置） -->
        <!--列表内容-->

        <el-table
          :data="tableData"
          style="width: 100%;margin:10px 0 0 0;"
          row-key="nav_id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          :default-sort="{prop: 'nav_id', order: 'ascending'}"
        >
          <el-table-column
            prop="article_id"
            label="ID"
            sortable
            >
          </el-table-column>
          <el-table-column
            prop="title"
            label="文章名称"
            sortable
            >
          </el-table-column>
          <el-table-column
            prop="acategory.cate_name"
            label="文章分类"
            sortable
            >
          </el-table-column>
          <el-table-column
            prop="addTimeText"
            label="添加时间">
          </el-table-column>

          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount" :page-size="10" class="pagination" @current-change="changePage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import MyHeader from "../header";
  import Cookies from "js-cookie"
  export default {
    name: "List",
    components: {
      MyHeader
    },
    data() {
      return {
        form: {
          parentName:'',
          typeName:'',
          moduleName:''
        },
        formLabelWidth:'120px',
        tableData: [],
        totalCount: 0,
        pageCount: 1,
        breadcrumb: [
          {
            name: '文章管理'
          },
          {
            name: '文章列表'
          }
        ],
        dialogFormVisible:false,
        arrType:[
          {label:'内部模块',value:1},
          {label:'外部链接',value:2}
        ],
        arrModule:[
          {label:'文章模块',value:1}
        ],
        showModule:false,
        showLink:false,
        dialogTitle:'添加文章',
        categoryList:[],
        parentList:[],
        page:1
      }
    },
    created(){
      this.form.nav_id = this.$route.query.id;
      this.getList(this.page);
    },
    methods:{
      getList(page){
        this.$http.get(this.apiUrl+'/v1/article/list',{params:{page:page}}).then(({data})=>{
          this.tableData = data.result.list;
          this.totalCount = parseInt(data.result.totalCount)
        })
      },
      changePage(val){
        this.page = val;
        this.getList(this.page)
      },
      clickAdd(){
        this.$router.push('/admin/article/edit')
      },
      clickConfirm(){
        this.$http.post('/v1/nav/save',this.form).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg);
            this.dialogFormVisible = false;
          }else{
            this.$message.error(data.msg);
          }
        })
      },
      handleEdit(index,row){
        this.$router.push('/admin/article/edit?id='+row.article_id)

      },
      handleDelete(index,row){
        this.$confirm('确定删除吗？').then(()=>{
          this.$http.post('/v1/article/delete',{'id':row.article_id}).then(({data})=>{
            if (data.errcode == 0){
              this.getList(this.page);
              this.$message.success(data.msg);
            }else{
              this.$message.error(data.msg);
            }
          })
        })
      },
      changeType(val){
        this.form.type = val;
        if (val == 1){
          this.showModule = true;
          this.showLink = false;

        }else {
          this.showLink = true;
          this.showModule = false;
          this.form.module_id = 0;
        }
      },
      changeModule(val){
        this.form.module_id = val;
        if (val == 1){
          this.$http.get('/v1/acategory/list?siteId='+Cookies.get('siteId')).then(({data}) => {
            this.categoryList = data.result;
          })
        }

      },
      changeCate(val){
        var _this = this;
        this.form.category_id = val;
        if (!this.form.nav_id){
          this.categoryList.forEach(function (item) {
            if(item.cate_id == val){
              _this.form.title =  item.cate_name;
            }
          })
        }

      },
      changeParent(val){
        var _this = this;
        this.form.parent_id  = val;
        this.tableData.forEach(function (item) {
          if (item.nav_id == val){
            _this.form.parentName = item.title;
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
